import {
	rePriceFormationOrderConstants
}from './constants'
import actions from '../../../actions'

const initialState =
{
	isSending  : false,
	paged      : {},
	list       : [],
	changed    : null,
	pagedAudit : null,
	countAudit : null
}

export default function (state = initialState, action){
	switch (action.type){
		case rePriceFormationOrderConstants.GetPaged.REQUEST:
		case rePriceFormationOrderConstants.GetPagedAudit.REQUEST:
		case rePriceFormationOrderConstants.GetPagedAll.REQUEST:
		case rePriceFormationOrderConstants.GetList.REQUEST:
		case rePriceFormationOrderConstants.Create.REQUEST:
		case rePriceFormationOrderConstants.Delete.REQUEST:
		case rePriceFormationOrderConstants.Restore.REQUEST:
		case rePriceFormationOrderConstants.Update.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case rePriceFormationOrderConstants.GetPaged.FAILURE:
		case rePriceFormationOrderConstants.GetPagedAudit.FAILURE:
		case rePriceFormationOrderConstants.GetPagedAll.FAILURE:
		case rePriceFormationOrderConstants.GetList.FAILURE:
		case rePriceFormationOrderConstants.Create.FAILURE:
		case rePriceFormationOrderConstants.Delete.FAILURE:
		case rePriceFormationOrderConstants.Restore.FAILURE:
		case rePriceFormationOrderConstants.Update.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload,
				changed   : null
			}
		case rePriceFormationOrderConstants.GetPaged.SUCCESS:
		case rePriceFormationOrderConstants.GetPagedAll.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case rePriceFormationOrderConstants.GetPagedAudit.SUCCESS:
			return {
				...state,
				isSending  : false,
				pagedAudit : action.payload.result.items,
				countAudit : action.payload.result.count
			}
		case rePriceFormationOrderConstants.GetList.SUCCESS:
			return {
				...state,
				isSending : false,
				list      : action.payload.result
			}
		case rePriceFormationOrderConstants.Create.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.create : null
			}
		case rePriceFormationOrderConstants.Delete.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case rePriceFormationOrderConstants.Update.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}
		case rePriceFormationOrderConstants.Restore.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.restore : null
			}
		case rePriceFormationOrderConstants.CLEAR:
			return {
				...state,
				changed    : null,
				isSending  : false,
				paged      : {},
				list       : [],
				pagedAudit : null,
				countAudit : null
			}
		default:
			return state
	}
}